<template>
    <div class="main-cn">
        <div class="main-bd mg20">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane v-for="(item, key) in active_list" :key="key" :label="item.label" :name="item.value" v-show="Acs('/performance-calc/' + item.value)"></el-tab-pane>
            </el-tabs>
            <SaleBonus v-if="activeName == 'sale-bonus'" :activeName="activeName" :key="1" @handleView="handleView"></SaleBonus>
            <SaleBonus v-else-if="activeName == 'merit-bonus'" :activeName="activeName" :key="2" @handleView="handleView"></SaleBonus>
            <CollectDetail v-else-if="activeName == 'collect-detail'"></CollectDetail>
            <ConfirmDetail v-else-if="activeName == 'confirm-detail'"></ConfirmDetail>
        </div>
    </div>
</template>
  <style scoped>
  
  </style>
  <script>
  import SaleBonus from "~/views/count/performance/SaleBonus.vue";
  import CollectDetail from "~/views/count/performance/CollectDetail.vue";
  import ConfirmDetail from "~/views/count/performance/confirmDetail.vue";
  export default {
    name: "performancecalc",

    components: {
        SaleBonus,
        CollectDetail,
        ConfirmDetail
    },
  
    props: {
        
    },
  
    data() {
      return {
        activeName: '',
        active_list: [
          {
            label: '销售提成业绩',
            value: 'sale-bonus',
          },
          {
            label: '绩效激励业绩',
            value: 'merit-bonus',
          },
          {
            label: '业绩汇总明细',
            value: 'collect-detail',
          },
          {
            label: '业绩确认表',
            value: 'confirm-detail',
          },
        ],
      };
    },
  
    mounted() {

    },
  
    created() {
      this.activeName = this.$route.query['activeName'] ? this.$route.query['activeName'].toString() : '';
      this.active_list = this.active_list.filter(item=>{
        if(!this.Acs('/performance-calc/' + item.value)){
          return false;
        }else if(!this.activeName){
          this.activeName = item.value;
        }
        return true;
      })
    },
  
    methods: {
        handleClick(tab, event) {

        },

        // 查看
        handleView(query) {
          query['activeName'] = 'collect-detail';
          let routeData = this.$router.resolve({
              path: "/count/performancecalc",
              query: query,
          });
          window.open(routeData.href, '_blank');
        },
    },
  };
  </script>


// WEBPACK FOOTER //
// src/views/count/performancecalc.vue